/* =========================================================
   ALUMEA PARIS — Theme JS
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* ----- Mobile menu toggle ----- */
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileMenuClose = document.querySelector('.mobile-menu .close');

  function openMenu() {
    if (mobileMenu) mobileMenu.classList.add('is-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
  }
  function closeMenu() {
    if (mobileMenu) mobileMenu.classList.remove('is-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
  }
  if (menuToggle && mobileMenu) menuToggle.addEventListener('click', openMenu);
  if (mobileMenuClose) mobileMenuClose.addEventListener('click', closeMenu);
  if (mobileMenu) {
    mobileMenu.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
  }

  /* ----- Cart drawer ----- */
  const cartBtn = document.querySelector('.cart-btn');
  function getCartDrawer() { return document.querySelector('.cart-drawer'); }
  function getCartOverlay() { return document.querySelector('.cart-overlay'); }

  function openCart() {
    const d = getCartDrawer(), o = getCartOverlay();
    if (d) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); }
    if (o) o.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    const d = getCartDrawer(), o = getCartOverlay();
    if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); }
    if (o) o.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (cartBtn) cartBtn.addEventListener('click', e => { e.preventDefault(); openCart(); });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.cart-close') || e.target.classList.contains('cart-overlay')) closeCart();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeMenu(); }
  });

  /* ----- Section rendering du tiroir ----- */
  function renderDrawerFromHTML(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newDrawer = doc.querySelector('.cart-drawer');
    const curDrawer = getCartDrawer();
    if (newDrawer && curDrawer) curDrawer.innerHTML = newDrawer.innerHTML;
  }
  function updateCartCount(count) {
    const el = document.querySelector('.cart-count');
    if (el) { el.textContent = count; el.style.display = count > 0 ? 'flex' : 'none'; }
  }
  async function refreshCart() {
    try {
      const cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
      updateCartCount(cart.item_count);
      const res = await fetch('/?section_id=cart-drawer');
      if (res.ok) renderDrawerFromHTML(await res.text());
    } catch (err) { console.error(err); }
  }

  /* ----- Add to cart ----- */
  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm) {
    productForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      const submitBtn = productForm.querySelector('[type="submit"]');
      const originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = (window.alumeaStrings && window.alumeaStrings.adding) || 'Ajout en cours…'; }

      const formData = new FormData(productForm);
      const body = {};
      formData.forEach((v, k) => { body[k] = v; });
      body.sections = ['cart-drawer'];
      body.sections_url = window.location.pathname;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || 'Ajout impossible');
        if (data.sections && data.sections['cart-drawer']) renderDrawerFromHTML(data.sections['cart-drawer']);
        const cart = await fetch('/cart.js').then(r => r.json());
        updateCartCount(cart.item_count);
        openCart();
      } catch (err) {
        console.error(err);
        showToast(err.message || (window.alumeaStrings && window.alumeaStrings.error) || 'Une erreur est survenue. Merci de réessayer.');
      } finally {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
      }
    });
  }

  /* ----- Modifier / retirer une ligne du tiroir ----- */
  async function changeLine(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: ['cart-drawer'] })
      });
      const data = await res.json();
      updateCartCount(data.item_count);
      if (data.sections && data.sections['cart-drawer']) renderDrawerFromHTML(data.sections['cart-drawer']);
      else await refreshCart();
    } catch (err) { console.error(err); }
  }
  document.addEventListener('click', function (e) {
    const remove = e.target.closest('[data-cart-remove]');
    const plus = e.target.closest('[data-cart-plus]');
    const minus = e.target.closest('[data-cart-minus]');
    if (remove) { e.preventDefault(); changeLine(remove.dataset.cartRemove, 0); }
    if (plus) {
      e.preventDefault();
      const q = parseInt(plus.closest('.cart-item').querySelector('.cart-item-qty').textContent, 10) || 1;
      changeLine(plus.dataset.cartPlus, q + 1);
    }
    if (minus) {
      e.preventDefault();
      const q = parseInt(minus.closest('.cart-item').querySelector('.cart-item-qty').textContent, 10) || 1;
      changeLine(minus.dataset.cartMinus, Math.max(0, q - 1));
    }
  });

  /* ----- Sélecteur de variante (fiche produit) ----- */
  document.querySelectorAll('[data-product-variants]').forEach(dataEl => {
    const form = dataEl.closest('form');
    if (!form) return;
    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const idInput = form.querySelector('[data-variant-id]');
    const selects = form.querySelectorAll('[data-product-option]');
    const priceEl = form.querySelector('[data-variant-price]');
    const comparePriceEl = form.querySelector('[data-variant-compare-price]');
    const discountBadgeEl = form.querySelector('[data-variant-discount-badge]');
    const addBtn = form.querySelector('.product-add-to-cart');
    if (!selects.length) return;

    const currentOptions = () => Array.from(selects).map(s => s.value);
    const matchVariant = opts => variants.find(v => v.options.every((o, i) => o === opts[i]));
    const formatMoney = cents => (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2 }) + ' €';

    function update() {
      const v = matchVariant(currentOptions());
      if (!v) { if (addBtn) { addBtn.disabled = true; addBtn.textContent = (window.alumeaStrings && window.alumeaStrings.unavailable) || 'Indisponible'; } return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (comparePriceEl) {
        if (onSale) { comparePriceEl.textContent = formatMoney(v.compare_at_price); comparePriceEl.hidden = false; }
        else { comparePriceEl.textContent = ''; comparePriceEl.hidden = true; }
      }
      if (discountBadgeEl) {
        if (onSale) {
          const pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
          discountBadgeEl.textContent = '-' + pct + '%';
          discountBadgeEl.hidden = false;
        } else { discountBadgeEl.textContent = ''; discountBadgeEl.hidden = true; }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? (((window.alumeaStrings && window.alumeaStrings.addToCart) || 'Ajouter au panier') + ' · ' + formatMoney(v.price)) : ((window.alumeaStrings && window.alumeaStrings.soldOut) || 'Bientôt de retour');
      }
    }
    selects.forEach(s => s.addEventListener('change', update));
    update();
  });

  /* ----- Quantité (fiche produit) ----- */
  document.querySelectorAll('.product-quantity .quantity-control').forEach(control => {
    const input = control.querySelector('input');
    const minus = control.querySelector('[data-qty-minus]');
    const plus = control.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', () => { const c = parseInt(input.value, 10) || 1; if (c > 1) input.value = c - 1; });
    if (plus) plus.addEventListener('click', () => { input.value = (parseInt(input.value, 10) || 1) + 1; });
  });

  /* ----- Galerie miniatures ----- */
  const mainImg = document.querySelector('.product-gallery .main-image img');
  document.querySelectorAll('.product-gallery .thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const inner = thumb.querySelector('img');
      const full = thumb.getAttribute('data-full') || (inner ? inner.getAttribute('src') : null);
      if (mainImg && full) {
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.setAttribute('src', full);
      }
      document.querySelectorAll('.product-gallery .thumb').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  /* ----- Fade-in au scroll ----- */
  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); obs.unobserve(entry.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });
    document.querySelectorAll('.fade-in').forEach(el => obs.observe(el));
  } else {
    document.querySelectorAll('.fade-in').forEach(el => el.classList.add('is-visible'));
  }

  /* ----- Toast discret ----- */
  function showToast(msg) {
    let t = document.querySelector('.alumea-toast');
    if (!t) { t = document.createElement('div'); t.className = 'alumea-toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(t._timer);
    t._timer = setTimeout(() => t.classList.remove('is-visible'), 3500);
  }

});
